import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [login, setLogin]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const { login: doLogin }      = useAuth();
  const navigate                = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const user = await doLogin(login.trim(), password);
      if (user.ruolo === 'UTENTE')     navigate('/cliente/catalogo');
      else if (user.ruolo === 'ALLENATORE') navigate('/allenatore');
      else navigate('/');
    } catch(err) {
      setError(err.response?.data?.error || 'Credenziali non valide');
      setPassword('');
    } finally { setLoading(false); }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>B-CHEERS ASD</div>
        <div style={s.sub}>GESTIONALE SPORTIVO</div>

        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.field}>
            <label style={s.label}>EMAIL O NOME UTENTE</label>
            <input style={s.input} type="text" value={login}
              onChange={e => setLogin(e.target.value)}
              placeholder="es. mario.rossi o mario@email.it"
              autoComplete="username" autoCapitalize="none" autoCorrect="off" spellCheck="false" required />
          </div>
          <div style={s.field}>
            <label style={s.label}>PASSWORD</label>
            <input style={s.input} type="password" value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password" required />
          </div>
          {error && <div style={s.error}>{error}</div>}
          {/* email mai confermata (21/10/2026): prima dal login non c'era modo di inserire il codice */}
          {/non ancora verificata/i.test(error) && (
            <button type="button" style={{ ...s.btn, background: 'transparent', color: '#C24B08', border: '1.5px solid #C24B08', marginTop: 0 }}
              onClick={() => navigate('/verify-email', { state: { email: login.includes('@') ? login.trim() : '', daLogin: true } })}>
              INSERISCI IL CODICE DI CONFERMA
            </button>
          )}
          <button type="submit" style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
            {loading ? 'ACCESSO...' : 'ACCEDI'}
          </button>
        </form>
        <div style={{ ...s.footer, marginTop:'14px' }}>
          <Link to="/password-dimenticata" style={s.link}>Password dimenticata?</Link>
        </div>
        <div style={s.footer}>
          Non hai un account? <Link to="/register" style={s.link}>Registrati</Link>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:  { minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center' },
  card:  { background:'var(--bg)', border:'1px solid var(--border)', borderRadius:'16px', padding:'48px 40px', width:'100%', maxWidth:'380px' },
  logo:  { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', color:'#F4600C', letterSpacing:'3px', textAlign:'center', marginBottom:'4px' },
  sub:   { fontSize:'var(--font-size-xs)', fontWeight:'700', color:'var(--text-dim)', letterSpacing:'2px', textAlign:'center', marginBottom:'36px' },
  form:  { display:'flex', flexDirection:'column', gap:'18px' },
  field: { display:'flex', flexDirection:'column', gap:'7px' },
  label: { fontSize: 'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'var(--text-dim)' },
  input: { background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'10px', padding:'12px 14px', color:'var(--text)', fontSize:'var(--font-size-sm)', outline:'none', width:'100%', boxSizing:'border-box' },
  error: { background:'#EF444420', border:'1px solid #EF444440', borderRadius:'8px', padding:'10px 14px', color:'#EF4444', fontSize:'var(--font-size-sm)', fontWeight:'600' },
  btn:    { background:'#F4600C', color:'#fff', border:'none', borderRadius:'10px', padding:'14px', fontSize:'var(--font-size-sm)', fontWeight:'700', cursor:'pointer', letterSpacing:'1px', marginTop:'4px' },
  footer: { textAlign:'center', marginTop:'20px', fontSize:'var(--font-size-sm)', color:'var(--text-dim)' },
  link:   { color:'#F4600C', textDecoration:'none', fontWeight:'700' },
};
